var __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/modules/es.symbol.description.js");